import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';
import { fetchSessions, SessionStats, UserSession } from './model';
export default function useSessionData() {
  const [items, setItems] = useState<UserSession[]>([]), [stats, setStats] = useState<SessionStats | null>(null);
  const [loading, setLoading] = useState(true), [error, setError] = useState('');
  const [total, setTotal] = useState(0), [partial, setPartial] = useState(false);
  const alive = useRef(true), generation = useRef(0);
  const reload = useCallback(async () => {
    const id = ++generation.current; setLoading(true); setError('');
    const [list, summary] = await Promise.allSettled([fetchSessions(), axios.get<SessionStats>(`${API_URL}/admin/sessions/stats`)]);
    if (!alive.current || id !== generation.current) return;
    if (list.status === 'fulfilled') { setItems(list.value.items); setTotal(list.value.total); setPartial(list.value.partial); }
    if (summary.status === 'fulfilled') setStats(summary.value.data);
    setError([list.status === 'rejected' ? 'Oturum listesi yüklenemedi. Varsa önceki kayıtlar korunuyor.' : '', summary.status === 'rejected' ? 'Özet bilgiler yenilenemedi.' : ''].filter(Boolean).join(' ')); setLoading(false);
  }, []);
  useEffect(() => { alive.current = true; reload(); return () => { alive.current = false; generation.current += 1; }; }, [reload]);
  return { items, stats, loading, error, total, partial, reload };
}
